import { parse } from "graphql";
export const REQUEST_SECURE_DATA = parse(`
    mutation requestSecureData($messageId: String!, $options: [SecureDataOptionInput!]!) {
        requestSecureData(messageId: $messageId, options: $options) {
            successCount
            failureCount
            result
        }
    }
`);